import React, {useRef, useState, useEffect, useContext} from 'react'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types'
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { BreakpointSmallMobile, BreakpointMobile, theme, BreakpointTablet } from '../Layout/GlobalStyle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Compressor from 'compressorjs';
import blobToBase64 from 'blob-to-base64'
import { updateUserAvatar, updateUsersFirstLastName, getUserAvatarByUserID } from '../../services/user.services';
import AuthUserContext from '../../providers/AuthProvider';
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto"


const ImageTile = styled.div`
    width: 50px;
    height: 50px;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${props => props.src? `url(${props.src})`: ``};
    margin: auto;
    cursor: pointer; 
    border-radius: 4px;
    ${props => props.isSelected && `transform: scale(1.1);`}
    ${props => props.isSelected && `box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);`}

  transition: 0.1s ease-in-out;
    .overlay{
      ${props => props.isSelected || props.showOverlay? `display: block;` :  `display: none;`}
      border-radius: 4px;
      width: inherit;
      height: inherit;
      position: absolute;
      background: rgba(0, 0, 0, 0.2);
    }
`


const useStyles = makeStyles((theme) => ({
    buttonClass: {
      width: "100%",
        fontFamily: "var(--Font1NotCondensed)",
        textTransform: 'initial'
    },
    buttonClassAccept: {
      width: "100%",
      fontFamily: "var(--Font1NotCondensed)",
      textTransform: 'initial',
      background: "rgb(74, 74, 74)",
      color: "white",
      "&:hover": {
        background: "rgb(44, 44, 44)",
      },
      "&:disabled": {
        background: "#ccc",
      }
    },
    buttonClassCancel: {
      width: "100%",
      fontFamily: "var(--Font1NotCondensed)",
      textTransform: 'initial',
      
    }
}))

const AvatarGrid = styled.div`
 display: grid;
grid-template-columns: repeat( auto-fill, minmax(50px, 1fr) );
  grid-row-gap: 8px;
  grid-column-gap: 5px;
`


const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    title: {
        fontSize: "large",
        fontFamily: "var(--Font1NotCondensed)"
    },
   
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography className={classes.title} variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  
const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      display: 'flex',
      justifyContent: "space-between",
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);


const DialogContent = withStyles((theme) => ({
    root: {
        width: 500,
        height: 400,
      padding: theme.spacing(2),
      [`@media only screen and (max-width: ${BreakpointTablet + "px"})`]: {
          width: 380,
          height: 380
      },
      [`@media only screen and (max-width: ${BreakpointMobile + "px"})`]: {
        width: "80vw",
        height: "90vh"
      }
    },
  }))(MuiDialogContent);
  
function UpdatePictureDialog({ open, setOpen, userID, oldPicture}) {
    let pictureRef = useRef(null)
    const [submitting, setSubmitting] = useState(false)
    const {setUserAvatar, getUserAvatar} = useContext(AuthUserContext)

    const [tempPicture, setTempPicture] = useState("")
    const classes = useStyles()

 
    const handlePicture = event => {
        new Compressor(event.target.files[0], {
            convertSize: 150,
            success(result) {
                blobToBase64(result, function (error, base64) {
                    let item = base64;
                    setTempPicture(item)
                })
            },
            error(err) {
                console.log(err.message);
            }
        })
    };

      const handleClose = () => {
        setTempPicture("")
        setSubmitting(false)
        setOpen(false);
      };
    
      
    

    const handleSubmit = () => {
        setSubmitting(true)
        let payload = {_id: userID, avatar: tempPicture}
        
        updateUserAvatar(payload)
        .then(res => {
             
                if(res.status >= 200){

                    getUserAvatar(userID)
                }
                setSubmitting(false)

            })
            .catch(err => {
                setSubmitting(false)

                throw err
            })
    }

    let renderAvatars = theme.avatars.map((ava, index) => {
      return <ImageTile isSelected={ava === tempPicture} onClick={() => setTempPicture(ava)} key={index} src={ava} width={50} height={50}>
        <div className="overlay"></div>
      </ImageTile>
    })
   
    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Select or upload a avatar
        </DialogTitle>
        <DialogContent>
            <input ref={pictureRef} hidden type="file" onChange={(e) => handlePicture(e)}></input>


            <AvatarGrid>
              <ImageTile showOverlay={true} src={!theme.avatars.includes(tempPicture)? tempPicture: ""} onClick={() => pictureRef.current.click()} >
                <div className="overlay"></div>
                <IconButton>
                  <AddAPhotoIcon />
                </IconButton>
              </ImageTile>
              {renderAvatars}

            </AvatarGrid>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} className={classes.buttonClassCancel}>Cancel</Button>
          <Button disabled={!tempPicture || submitting} className={classes.buttonClassAccept} disableElevation  onClick={() => handleSubmit()} color="primary">
            {submitting? "Saving changes":"Save Changes"}

          </Button>
        </DialogActions>
        </Dialog>
    )
}

UpdatePictureDialog.defaultProps = {
    open: false
}

UpdatePictureDialog.propTypes = {
    setOpen: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    oldPicture: PropTypes.string.isRequired,
    userID: PropTypes.string.isRequired,
}

export default UpdatePictureDialog
